import { mastraClient, mastraClientAuth, CRM_AGENT_ID } from '../../client'
import * as types from './types'

export * from './types'

const mapThread = (
  thread: any,
  fallbackResourceId: string
): types.IGetMemoryThreadsItemData => ({
  id: thread?.id,
  title: thread?.title || 'Untitled',
  createdAt: thread?.createdAt || '',
  updatedAt: thread?.updatedAt || '',
  resourceId: thread?.resourceId || fallbackResourceId,
})

export const getMemoryThreadsPaginated = async (
  params: types.IGetMemoryThreadsPaginatedParams
): Promise<{ data: types.IGetMemoryThreadsPaginatedData }> => {
  mastraClientAuth()

  const threadsResponse = await mastraClient.listMemoryThreads({
    page: params.page,
    perPage: params.perPage,
    // @ts-ignore
    orderBy: params.orderBy,
    sortDirection: params.sortDirection,

    resourceId: params.resourceId,
    agentId: params.agentId || CRM_AGENT_ID,
  })

  const threads = threadsResponse.threads || []

  return {
    data: {
      hasMore: threadsResponse.hasMore || false,
      page: threadsResponse.page || params.page,
      perPage: threadsResponse.perPage || params.perPage,
      total: threadsResponse.total || threads.length,
      threads: threads.map((thread: any) =>
        mapThread(thread, params.resourceId)
      ),
    },
  }
}

export const postMemoryThreads = async (
  params: types.IPostMemoryThreadsParams
): Promise<{ data: types.IPostMemoryThreadsData }> => {
  mastraClientAuth()
  const thread = await mastraClient.createMemoryThread({
    title: params.title,
    metadata: params.metadata,
    resourceId: params.resourceId,
    // threadId: params.threadId,
    agentId: params.agentId || CRM_AGENT_ID,
  })

  return { data: mapThread(thread, params.resourceId) }
}

export const patchMemoryThreadsItem = async (
  params: types.IPatchMemoryThreadsItemParams & {
    title?: string
    metadata?: any
  }
): Promise<{ data: types.IPatchMemoryThreadsItemData }> => {
  mastraClientAuth()
  const thread = mastraClient.getMemoryThread({
    threadId: params.threadId,
    agentId: params.agentId || CRM_AGENT_ID,
  })

  const updated = await thread.update({
    title: params.title || '',
    metadata: params.metadata || {},
    resourceId: params.resourceId,
  })

  return { data: updated as types.IPatchMemoryThreadsItemData }
}

export const deleteMemoryThreadsItem = async (
  params: types.IDeleteMemoryThreadsItemParams
): Promise<{ data: types.IDeleteMemoryThreadsItemData }> => {
  mastraClientAuth()
  const thread = mastraClient.getMemoryThread({
    threadId: params.threadId,
    agentId: params.agentId || CRM_AGENT_ID,
  })
  await thread.delete({
    // @ts-ignore
    resourceId: params.resourceId,
  })

  return { data: {} }
}

export const getMemoryThreadsItemMessages = async (
  params: types.IGetMemoryThreadsItemMessagesParams
): Promise<{ data: types.IGetMemoryThreadsItemMessagesData }> => {
  mastraClientAuth()
  const thread = mastraClient.getMemoryThread({
    threadId: params.threadId,
    agentId: params.agentId || CRM_AGENT_ID,
  })
  const messages = await thread.listMessages({
    // perPage: params.limit,
    resourceId: params.resourceId,
    // requestContext: { resourceId: params.resourceId },
  })

  return {
    data: {
      messages: (messages.messages || []).map((msg) => ({
        ...msg,
        createdAt:
          msg.createdAt instanceof Date
            ? msg.createdAt.toISOString()
            : typeof msg.createdAt === 'string'
            ? msg.createdAt
            : new Date().toISOString(),
      })) as types.IMemoryThreadMessage[],
    },
  }
}
